import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import store from 'Redux/store';

export default function FantasyVerseLink({ setMegaMenuTab, megaMenuTab }) {
  const [delayHandler, setDelayHandler] = useState(null);

  const clickButton = () => {
    setMegaMenuTab(megaMenuTab === '' ? 'fantasyVerse' : '');
    setTimeout(() => {
      const navLink = document.getElementById('fantasyverse-megamenu');
      if (navLink) navLink.focus();
    }, 200);

    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'SecondaryNavLinks', value: '/fantasyverse', context: 'FantasyVerse' },
    });
  };

  const handleMouseEnter = () => {
    setDelayHandler(setTimeout(() => {
      setMegaMenuTab('fantasyVerse');
    }, 200));
  };

  const handleMouseLeave = () => {
    clearTimeout(delayHandler);
    setMegaMenuTab('');
  };

  return (
    <div className="store-link-button">
      <Link
        aria-expanded={megaMenuTab === 'fantasyVerse'}
        aria-controls="MegaMenu_fantasyVerse"
        aria-haspopup="true"
        aria-label="fantasyverse, dropdown"
        to="/fantasyverse"
        className="secondary-nav-link"
        onClick={() => { clickButton(); }}
        onMouseEnter={() => { handleMouseEnter(); }}
        onMouseLeave={() => { handleMouseLeave(); }}
      >
        FantasyVerse
        <div className="link-arrow" />
      </Link>
    </div>
  );
}

FantasyVerseLink.propTypes = {
  setMegaMenuTab: PropTypes.func,
  megaMenuTab: PropTypes.string,
};

FantasyVerseLink.defaultProps = {
  setMegaMenuTab: () => { },
  megaMenuTab: '',
};
